export default __webpack_public_path__ + "static/emilpixelado-50af6c2dc8adbbdc21c64df2ac97e091.png";